import { render, staticRenderFns } from "./RefSystem.vue?vue&type=template&id=4347b7ee&scoped=true"
import script from "./RefSystem.vue?vue&type=script&lang=js"
export * from "./RefSystem.vue?vue&type=script&lang=js"
import style0 from "./RefSystem.vue?vue&type=style&index=0&id=4347b7ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4347b7ee",
  null
  
)

export default component.exports